import { Compass, LinkedinLogo } from "@phosphor-icons/react";
import clsx from "clsx";

import RenderIf from "common/components/RenderIf";
import type { WorkspaceAccount } from "common/types";

export default function AccountName({
  account,
  className,
}: {
  account: WorkspaceAccount;
  className: string;
}) {
  const {
    full_name: fullName,
    premium: isPremium,
    sales_navigator: isSalesNavigator,
  } = account;

  return (
    <div className="flex items-center gap-x-1">
      <span className={clsx("line-clamp-1 break-all", className)}>
        {fullName}
      </span>

      <RenderIf condition={isPremium}>
        <LinkedinLogo className="fill-yellow-500 size-4" weight="fill" />
      </RenderIf>

      <RenderIf condition={isSalesNavigator}>
        <Compass weight="fill" className="fill-blue-500 size-4" />
      </RenderIf>
    </div>
  );
}
